import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { useLocale } from 'pe-core-frontend';
import { useEffect } from 'react';
import { useExports } from '../../hooks/useExports';
export const ExportPicker = (props) => {
    const { t } = useLocale();
    const { items, loading } = useExports({
        clientId: props.clientId,
    });
    useEffect(() => {
        if (props.value && props.onInit) {
            props.onInit(items?.find(x => String(x.id) === props.value));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);
    const handleOnChange = (event) => {
        if (props.onChange) {
            props.onChange(items?.find(x => String(x.id) === event.target.value));
        }
    };
    return (_jsx(_Fragment, { children: !loading && (_jsx(Select, { label: props.label ?? '', helpText: props.helpText ?? '', placeholder: props.placeholder ?? t('Select'), onChange: handleOnChange, options: items?.map(item => ({
                value: String(item.id),
                label: item.name,
            })) ?? [], className: props.className, value: props.value })) }));
};
